import React from "react";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../icons";
import clsx from "clsx";
import Tooltip from "../../atom/Tooltip";

interface SideBarToggleButtonProps {
  onClick: () => void;
  isExpanded: boolean;
}
export const SideBarToggleButton: React.FC<SideBarToggleButtonProps> = ({
  onClick,
  isExpanded,
}) => {
  return (
    <Tooltip
      content={`${isExpanded ? "Close" : "Open"} sidebar`}
      side={"right"}
      className="origin-left"
    >
      <button
        onClick={onClick}
        onFocus={(e) => {
          e.currentTarget.blur();
          e.preventDefault();
        }}
        aria-label={`toggle sidebar`}
        className={clsx(
          `group mx-[2px] flex h-[28px] w-[28px] items-center justify-center rounded-[5px] border-none hover:bg-[rgba(255,255,255,0.08)] focus:shadow-none focus:outline-none`,
          "transition-colors duration-200"
        )}
        title={`toggle sidebar`}
      >
        {/* ArrowLeftIcon - 사이드바가 열러있을 때(250px 이상일 때)만 보임 */}
        <div
          className={`hidden text-[#cacdce] transition-colors duration-200 group-hover:text-white @[250px]/sidebar:block`}
        >
          <ArrowLeftIcon />
        </div>

        {/* ArrowRightIcon - 사이드바가 닫혀있을 때(250px 미만일 때)만 보임 */}
        <div
          className={`block text-[#cacdce] transition-colors duration-200 group-hover:text-white @[250px]/sidebar:hidden`}
        >
          <ArrowRightIcon />
        </div>
      </button>
    </Tooltip>
  );
};
